define('app/views/landing_page_view',['app/setup'], function(takhfifan) {

  takhfifan.LandingPageView = Backbone.View.extend({

    initialize: function() {
      this.handleIndexRedirect();
    },

    handleIndexRedirect: function() {
      var cityPath = $.cookie('city');
      var defaultPath = this.$el.data('cityPath');

      if (_.isString(cityPath) && cityPath != defaultPath
          && _.isNaN(parseInt(cityPath))
      ) {
        window.location.href = '/' + cityPath;
      }
    }

  });

  var $lp = $('#tkh-landing-page');

  if ($lp.length > 0) {
    new takhfifan.LandingPageView({el: $lp});
  };

});

